__turbopack_context__.v({
  "aside": "NavBar-module__Cg40yG__aside",
  "avatar": "NavBar-module__Cg40yG__avatar",
  "footer": "NavBar-module__Cg40yG__footer",
  "footerDivider": "NavBar-module__Cg40yG__footerDivider",
  "navLink": "NavBar-module__Cg40yG__navLink",
  "navStack": "NavBar-module__Cg40yG__navStack",
});
